import { useGetJournalEntryCountsByMonthFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { ViewStateWrapper } from "UIPalette/ViewStateWrapper/ViewStateWrapper";
import { useTranslation } from "react-i18next";
import { EntryChartBar } from "./EntryChartBar";

export function EntryChart() {
  const { data: monthlyStats, isLoading, error, mutate } = useGetJournalEntryCountsByMonthFunctionRequest({});
  const { t } = useTranslation();
  const monthlyCounts = Array(12).fill(0);

  monthlyStats?.months?.forEach((month) => {
    monthlyCounts[month.month - 1] = month.entryCount;
  });

  const totalEntriesThisYear = monthlyCounts.reduce((total, count) => total + count, 0);

  return (
    <RoundedCard className="h-40 p-6">
      <ViewStateWrapper loading={isLoading} error={!!error} onRetry={mutate} errorMessage={t("positiveYou.entryChart.error")}>
        <div className="flex h-full items-center gap-5">
          <p className="flex shrink-0 flex-col justify-center leading-none">
            <span className="text-brand text-stat font-bold">{totalEntriesThisYear}</span>
            <span className="mt-3 font-semibold leading-tight">{t("positiveYou.entryChart.description.line1")}</span>
            <span>{t("positiveYou.entryChart.description.line2")}</span>
          </p>
          <div className="min-w-0 flex-1 h-full">
            <EntryChartBar monthlyCounts={monthlyCounts} />
          </div>
        </div>
      </ViewStateWrapper>
    </RoundedCard>
  );
}
